"use client";
import { IBlocks } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import { cn } from "@/lib/utils";

interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockDivider({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={`pb-5 ${block.show ? "" : "opacity-30"}`}
            title={"Divider"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                className={cn(
                    `mb-2 mt-1 w-full border-b-2 ${edit && "pt-5"}`,
                    "block-" + block.id
                )}
                id="divider"
                style={{
                    borderColor: blockUpdate.style?.custom
                        ? blockUpdate.style?.colors.primary
                        : "white",
                }}
            />
        </AdminPopover>
    );
}
